export const project = {
  title: 'Box Roulette',
  summary: 'A gambling-style box-picking game built with Vue.js.',
}
